export const EDITING_TOGGLED = 'EDITING_TOGGLED';
export const END_GAME = 'END_GAME';
export const NEW_GAME = 'NEW_GAME';
export const SQUARE_SET = 'SQUARE_SET';
export const UNDO_MOVE = 'UNDO_MOVE';
